import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Modal,Navbar} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from '../UserContext'
import uuid from 'react-uuid'

export default function Firms() {


    const OikosName=useRef('')
    const OikosNameEng=useRef('')
    const OikosCounNameGr=useRef('')
    const OikosCounNameEng=useRef('')
    const OikosEmail=useRef('')

    const {accountingData,setAccountingData}=useContext(UserContext)
    const {catalogueData,setCatalogueData}=useContext(UserContext)
    const {activeTab,setActiveTab}=useContext(UserContext)
    const {oikoi,setOikoi}=useContext(UserContext)
    const [show,setShow]=useState(false)
    const {exhibition,setExhibition}=useContext(UserContext)
    const {sendForm}=useContext(UserContext)
    const {countriesListGr,countriesListEng}=useContext(UserContext)
    


    const handleClose=()=>{
        setShow(false)
    }

    useEffect(()=>{
        //console.log('x='+catalogueData.ACTIVITYID)
        if (catalogueData.ACTIVITYID && oikoi.length==0){
            
            axios.get(process.env.REACT_APP_API+'firms/'+catalogueData.ACTIVITYID,{
                headers: {
                    'Authorization': 'Bearer '+process.env.REACT_APP_TOKEN
                }            
            }).then(res=>{
                setOikoi(res.data)
                //console.log(res.data)
            })
        }
    },[activeTab])

    const removeFirm=(CMID,Name)=>{
        if (window.confirm("ΔΙΑΓΡΑΦΗ ΟΙΚΟΥ / DELETE FIRM: " +Name +"?")){
           setOikoi([...oikoi.filter(itm=>itm.CMID!=CMID)])
        }
    }

    const firmsList=oikoi.map((item,index)=>{
        return(
            <>
            <Card key={item.CMID}>
            <Card.Body>
             <Card.Title>{item.USKATALOGOSONOMAOIKOUELL} // {item.USKATALOGOSONOMAOIKOUENG}</Card.Title>
            <Card.Text>
            {item.USKATALOGOSOIKOXORA} // {item.USKATALOGOSOIKOSXORAENG}<br/>
            {item.USKATALOGOSOIKOEMAIL}
            <p align="right">
                <Button variant="secondary" onClick={()=>removeFirm(item.CMID,item.USKATALOGOSONOMAOIKOUELL)}>X</Button>
            </p>
            </Card.Text>
            </Card.Body>
            </Card>
            <br/>
            </>

        )
    })

    const saveFirm=(e)=>{
        e.preventDefault()
        const oikos={
            CMID:uuid(),
            USKATALOGOSOIKOEMAIL: OikosEmail.current.value,
            USKATALOGOSOIKOSXORAENG: OikosCounNameEng.current.value,
            USKATALOGOSOIKOXORA: OikosCounNameGr.current.value,
            USKATALOGOSONOMAOIKOUELL: OikosName.current.value,
            USKATALOGOSONOMAOIKOUENG: OikosNameEng.current.value
        }

        setOikoi([oikos,...oikoi])
        setShow(false)
    }


    return (
        <Container fluid>
        <>
        <Alert variant='success'>
          <h4>ΟΙΚΟΙ // FIRMS</h4>
          </Alert>
            <p align="right"><Button variant="success" onClick={()=>setShow(true)}>Προσθήκη Οίκου // Add Firm</Button></p>

          {firmsList}

          <>  
            <br/><br/><br/><br/>
            <Navbar bg="light" fixed="bottom" >
                <table width="100%"><tbody><tr>
                  
                  <td align="left">
                    {accountingData.CMTIN && 
                      <Button variant="secondary" onClick={()=>sendForm(1)}>ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ // TEMPORARY SAVE</Button>
                    }
                
  
              </td>  <td align="right">
                <Button  variant="secondary" onClick={()=>{window.scroll(0,0);exhibition.XP==0 ? setActiveTab('catalogue') : setActiveTab('b2b')}}>ΠΙΣΩ // BACK</Button>
                 &nbsp;
                <Button  variant="success" onClick={()=>{window.scroll(0,0);setActiveTab('exhibits')}}>ΕΠΟΜΕΝΟ // NEXT</Button>
                </td></tr></tbody></table>
            </Navbar> 
            </>

        {/* <p align="right">
        <Button  variant="secondary" onClick={()=>{window.scroll(0,0);setActiveTab('catalogue')}}>ΠΙΣΩ // BACK</Button>
        &nbsp;
        <Button  variant="success" onClick={()=>{window.scroll(0,0);setActiveTab('exhibits')}}>ΕΠΟΜΕΝΟ // NEXT</Button>
        </p>           */}
        </>



        <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                <Modal.Title>
                    Προσθήκη Οίκου // Add Firm
                </Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                <Form onSubmit={saveFirm}>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Επωνυμία Οίκου στα ελληνικά // Firm Name</Form.Label>
                        <Form.Control type="text" required ref={OikosName}/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Επωνυμία Οίκου στα αγγλικά // Firm Name in english</Form.Label>
                        <Form.Control type="text" required ref={OikosNameEng}/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Χώρα // Country (in greek)</Form.Label>
                        {/* <Form.Control type="text" required ref={OikosCounNameGr} /> */}
                        <Form.Select  ref={OikosCounNameGr}>
                        <option value=''>[ΕΠΙΛΕΞΤΕ ΧΩΡΑ // SELECT COUNTRY]</option>
                        {countriesListGr}
                        </Form.Select>                           
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Χώρα στα αγγλικά // Country (in english)</Form.Label>
                        {/* <Form.Control type="text" required ref={OikosCounNameEng}/> */}
                        <Form.Select  ref={OikosCounNameEng}>
                        <option value=''>[ΕΠΙΛΕΞΤΕ ΧΩΡΑ // SELECT COUNTRY]</option>
                        {countriesListEng}
                        </Form.Select>   

                    </Form.Group>


                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" required ref={OikosEmail}/>
                    </Form.Group>
                    <hr/>




                    <p align="right">
                    <Button variant="success" type="submit">Αποθήκευση // Save</Button>
                    </p>

                </Form>

                </Modal.Body>
            </Modal>


        </Container>
  
    )
}
